import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  fill: "#6B93C0",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16 8A8 8 0 110 8a8 8 0 0116 0z" }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      d: "M8.957 8.25l2.09 2.11c.156.143.156.286 0 .43l-.488.487c-.144.157-.287.157-.43 0l-2.11-2.09-2.109 2.09c-.143.157-.286.157-.43 0l-.488-.488c-.156-.143-.156-.286 0-.43l2.09-2.109-2.09-2.11c-.156-.143-.156-.286 0-.43l.488-.487c.144-.157.287-.157.43 0l2.11 2.09 2.109-2.09c.143-.157.286-.157.43 0l.488.488c.156.143.156.286 0 .43L8.957 8.25z",
      fill: "#fff"
    }, null, -1 /* HOISTED */)
  ])))
}